import { ENV } from "utils/constants";
/**
 * Sentry Logger
 *
 * Uses Raven.js from Sentry for error reporting
 *
 * Config:
 * 	https://docs.sentry.io/clients/javascript/
 */
/* eslint-disable indent */
export function errorLog(crash){
	if(crash && crash.console) {
		console.groupCollapsed("%cCaught Error:%c", "background-color:#db6662; color:#fff; display:block; padding:0 25rem 0 1rem;", "background-color:#fff; color:#000; padding:0;");
			console.info("There was an error through Redux:");
			console.error(crash.error);
		console.groupEnd();
	}

	if(typeof(Raven) === "undefined" || !Raven) { return null; }

	Raven.captureException(crash.error, crash.context);
}

export function breadcrumbLog(crumb){
	if(crumb && crumb.console) {
		console.groupCollapsed("Adding Crumb:");
			console.info("Breadcrumb Action:");
			console.table(crumb);
		console.groupEnd();
	}

	if(typeof(Raven) === "undefined" || !Raven) { return null; }

	Raven.captureBreadcrumb(crumb);
}

const Rave = {
	errorLog,
	breadcrumbLog,
};


export function tellSentry(what){
	if(/dev|development/.test(ENV)){
		console.groupCollapsed("%cSentry Message:%c", "background-color:#d2019b; color:#fff; display:block; padding:0 25rem 0 1rem; border-radius:20px;", "background-color:#fff; color:#000; padding:0;");
			console.log("Sentry disabled locally, hooked up, message not sent!");
			console.info(what);
		console.groupEnd();
		return;
	}

	try {
		Sentry.captureMessage(what);
	} catch (err){
		/* eslint-disable */
		console.group("Sentry Issue!");
			console.warn("Sentry is not enabled, the message was not sent!");
			console.log(what);
		console.groupEnd();
		/* eslint-enable */
	}
}

export default Rave;
/* eslint-enable indent */
